export const size = {
  mobileSmall: 600,
  mobile: 768,
  tablet: 992,
  laptop: 1024,
  desktop: 2024
}

export const deviceSize = {
  mobileSmall: `(max-width: ${size.mobileSmall}px)`,
  mobile: `(max-width: ${size.mobile}px)`,
  tablet: `(max-width:${size.tablet}px)`,
  laptop: `(max-width:${size.laptop}px)`,
  desktop: `(max-width: ${size.desktop}px)`
}